var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyRight"},[_c('p',[_vm._v("Copyright © www.ymkjc.com All Rights Reserved.")]),_c('p',[_vm._v("广州源码区块链科技有限公司 | 技术支持")])])}]

export { render, staticRenderFns }